<template>
  <!--begin::Timeline item-->
  <div id="third" class="timeline-item">
    <!--begin::Timeline line-->
    <div class="timeline-line w-40px"></div>
    <!--end::Timeline line-->

    <!--begin::Timeline icon-->
    <div class="timeline-icon symbol symbol-circle symbol-40px me-4">
      <div class="symbol-label "
           :class="{
              'bg-light-success': thirdInstance.is_favorable,
              'bg-light-danger': !thirdInstance.is_favorable
          }">
        <i class="bi bi-3-circle-fill fs-2 "
           :class="{
              'text-success': thirdInstance.is_favorable,
              'text-danger': !thirdInstance.is_favorable
          }"></i>
      </div>
    </div>
    <!--end::Timeline icon-->

    <!--begin::Timeline content-->
    <div class="timeline-content mb-10 mt-n1">
      <!--begin::Timeline heading-->
      <div class="pe-3 mb-5">
        <!--begin::Title-->
        <div
             class="text-gray-800 fw-bold fs-4">
          <span id="edit_judicial_precedent_third_instance_drawer_toggle" class="">
          {{ thirdInstance.type.name }}
          </span>
          <span class="badge ms-2"
                :class="{
                  'badge-success': thirdInstance.is_favorable,
                  'badge-danger': !thirdInstance.is_favorable
          }">
            {{ thirdInstance.is_favorable ? 'Favorable' : 'Desfavorable' }}
          </span>
        </div>
        <!--end::Title-->
      </div>
      <!--end::Timeline heading-->

      <!--begin::Timeline details-->
      <div class="overflow-auto pb-5">
        <!--begin::Info-->
        <div class="d-flex flex-wrap mb-5">
          <!--begin::Due-->
          <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-7 mb-3">
            <div class="fs-6 text-gray-800 fw-bold">
              {{ thirdInstance.date }}
            </div>
            <div class="fw-semibold text-gray-400">Fecha sentencia</div>
          </div>
          <!--end::Due-->
          <!--begin::Due-->
          <div v-if="thirdInstance.date_demand" class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-7 mb-3">
            <div class="fs-6 text-gray-800 fw-bold">
              {{ thirdInstance.date_demand }}
            </div>
            <div class="fw-semibold text-gray-400">Fecha demanda</div>
          </div>
          <!--end::Due-->
        </div>

        <!--end::Info-->
        <div class="d-flex flex-wrap mb-5">
          <div class="w-lg-50">
            <h3 class="card-title d-flex align-items-center flex-stack flex-wrap d-grid gap-1 flex-row-fluid">
                <span class="card-label fw-bold text-gray-800">
                  {{ thirdInstance.file_url ? 'Adjunto' : 'Sin adjunto'}}
                </span>
            </h3>
            <!--begin::Body-->
            <div v-if="thirdInstance.file_url" class="pt-3">
              <!--begin::Item-->
              <div class="d-flex flex-stack">
                <!--begin::Title-->
                <button @click="downloadBlob(currentUser.currentPlan)" class="btn btn-primary">Descargar adjunto</button>
                <!--end::Title-->
              </div>
              <!--end::Item-->
            </div>
          </div>
        </div>
        <hr class="border-dashed border-primary">
      </div>
      <!--end::Timeline details-->
    </div>
    <!--end::Timeline content-->
  </div>
  <!--end::Timeline item-->
</template>

<script lang="ts">
import {defineComponent, PropType, ref, nextTick, onMounted} from "vue";
import {JudicialPrecedent, JudicialPrecedentInstance} from "~/types/interfaces/entitites/JudicialPrecedentInterface";
import {useJudicialPrecedentsClientStore} from "~/stores/entities/client/judicialPrecedentClient";
import {useAuthStore} from "~/stores/auth";
import {storeToRefs} from "pinia";
import {Plan} from "~/types/interfaces/entitites/PlanInterface";
import {useUtil} from "~/composables/useUtil";
import {number} from "yup";
import {useConfigStore} from "~/stores/config";


export default defineComponent({
  name: "third-instance",
  components: {},
  props: {
    thirdInstance: {type: Object as PropType<JudicialPrecedentInstance>, required: true},
    instance: {type: Object as PropType<JudicialPrecedent>, required: true},
  },
  setup(props) {
    const configStore = useConfigStore();
    const route = useRoute();
    const judicialPrecedentsClientStore = useJudicialPrecedentsClientStore();
    const store = useAuthStore();
    const {currentUser} = storeToRefs(store);
    let automaticDownloads = ref<number>(0);
    const {setPageTitle} = configStore;

    onMounted(() => {
      nextTick(() => {
        checkAutomaticDownload();
      });
    });

    const checkAutomaticDownload = () => {
      if (currentUser.value.currentPlan && route.query.download !== undefined) {
        if (automaticDownloads.value === 0 && route.query.download === '3') {
          downloadBlob(currentUser.value.currentPlan)
          automaticDownloads.value += +1;
          setPageTitle(props.thirdInstance.file_name);
        }
      }
    };

    const canDownload = (plan: Plan): boolean => {
      return plan.name === 'Pleno+' || plan.name === 'Pleno vulnerable';
    };

    const downloadBlob = async (plan: Plan) => {
      if (canDownload(plan)) {
        useUtil().showLoading();

        // Perform an HTTP request to fetch the Blob data
        const response = await judicialPrecedentsClientStore.download(route.params.hash, props.thirdInstance.hash);

        // Create a URL for the Blob data
        const blobURL = window.URL.createObjectURL(response);

        // Create an <a> element to trigger the download
        const downloadLink = document.createElement('a');
        downloadLink.href = blobURL;
        downloadLink.download = props.instance.slug + '_' + props.thirdInstance.type.slug + '.pdf';

        // Trigger the download
        downloadLink.click();

        // Clean up by revoking the Blob URL
        window.URL.revokeObjectURL(blobURL);
        useUtil().closeLoading();
        useUtil().defaultDownloadSuccess();
      } else {
        useUtil().defaultError('Permiso denegado', 'Necesitas una suscripción superior para poder descargar estos archivos.');
      }
    };

    return {
      currentUser,
      downloadBlob
    };
  },
});
</script>
